"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ElementDefinition_Type = exports.ElementDefinition_TypeVersioningKind = exports.ElementDefinition_TypeAggregationKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var ElementDefinition_TypeAggregationKind;
(function (ElementDefinition_TypeAggregationKind) {
    ElementDefinition_TypeAggregationKind["_contained"] = "contained";
    ElementDefinition_TypeAggregationKind["_referenced"] = "referenced";
    ElementDefinition_TypeAggregationKind["_bundled"] = "bundled";
})(ElementDefinition_TypeAggregationKind = exports.ElementDefinition_TypeAggregationKind || (exports.ElementDefinition_TypeAggregationKind = {}));
var ElementDefinition_TypeVersioningKind;
(function (ElementDefinition_TypeVersioningKind) {
    ElementDefinition_TypeVersioningKind["_either"] = "either";
    ElementDefinition_TypeVersioningKind["_independent"] = "independent";
    ElementDefinition_TypeVersioningKind["_specific"] = "specific";
})(ElementDefinition_TypeVersioningKind = exports.ElementDefinition_TypeVersioningKind || (exports.ElementDefinition_TypeVersioningKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ElementDefinition_Type = t.recursion('IElementDefinition_Type', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        code: RTTI_uri_1.RTTI_uri,
        _code: RTTI_Element_1.RTTI_Element,
        profile: t.array(RTTI_canonical_1.RTTI_canonical),
        targetProfile: t.array(RTTI_canonical_1.RTTI_canonical),
        aggregation: t.array((0, EnumType_1.createEnumType)(ElementDefinition_TypeAggregationKind, 'ElementDefinition_TypeAggregationKind')),
        _aggregation: t.array(RTTI_Element_1.RTTI_Element),
        versioning: (0, EnumType_1.createEnumType)(ElementDefinition_TypeVersioningKind, 'ElementDefinition_TypeVersioningKind'),
        _versioning: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_ElementDefinition_Type.js.map